<template>
    <span class="c-copy-text">
        <span class="u-text">{{ displayText }}</span>
        <el-icon
            v-if="canCopy"
            class="u-copy"
            :title="title || '复制'"
            @click.stop="handleCopy"
        >
            <DocumentCopy />
        </el-icon>
    </span>
</template>

<script>
import { copyText } from "@/utils";

export default {
    name: "CopyTextValue",
    props: {
        text: {
            type: [String, Number],
            default: "",
        },
        title: {
            type: String,
            default: "复制",
        },
        emptyText: {
            type: String,
            default: "-",
        },
        copyValue: {
            type: [String, Number],
            default: "",
        },
        showCopy: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        displayText() {
            return this.text !== null && this.text !== undefined && this.text !== "" ? this.text : this.emptyText;
        },
        finalCopyValue() {
            if (this.copyValue !== null && this.copyValue !== undefined && this.copyValue !== "") {
                return this.copyValue;
            }
            return this.text;
        },
        canCopy() {
            return this.showCopy && !!this.finalCopyValue;
        },
    },
    methods: {
        handleCopy() {
            if (!this.canCopy) return;
            copyText(this.finalCopyValue);
        },
    },
};
</script>

<style lang="less">
.c-copy-text {
    display: inline-flex;
    align-items: baseline;
    gap: 6px;
    max-width: 100%;
    line-height: inherit;
    vertical-align: middle;

    .u-text {
        word-break: break-all;
        line-height: inherit;
    }

    .u-copy {
        flex-shrink: 0;
        cursor: pointer;
        color: #909399;
        transition: color 0.2s ease;
        font-size: 14px;
        position: relative;
        top: 1px;

        &:hover {
            color: #409eff;
        }
    }
}
</style>
